import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [MatIconModule, TranslatePipe],
  selector: 'app-empty-grid-container',
  templateUrl: './empty-grid-container.component.html',
  styleUrls: ['./empty-grid-container.component.scss'],
  standalone: true,
})
export class EmptyGridContainerComponent {
  @Input()
  translationKey = 'commons.grid.empty';
}
